import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-error',
  template: `
<div class="small mt-2 text-danger">
  <fa name="angle-double-up"></fa>
  <span [id]="ElementID" aria-live="assertive" aria-relevant="additions removals">{{ ErrorMessage }}</span>
</div>
`
})
export class FormErrorComponent {
  @Input() ElementID: string = '';
  @Input() ErrorMessage: string = '';
}



// WEBPACK FOOTER //
// ./src/app/global/formerror.component.ts